import React from "react"
import Layout from "../components/layout/Layout"
import SEO from "../components/SEO"
import { graphql } from 'gatsby';
import { mapPageData } from '../utils/Mappers';
import useModules from '../utils/useModules';
import PageNav from '../components/layout/PageNav';


const Typography = ({ data={} }) => {

  const { modules, title, description=false, id } = mapPageData(data.page)

  const [modulesToRender, heroModule ] = useModules(modules, { getHeroModule: true })

  return (
  <>
  <SEO title={title} description={description}/>
  <Layout 
    staticMenuLayout={true}
    homeLink={true}
    staticMenu={true}
    heroModule={heroModule}
    objectPosition="75% 50%"
    className="static-page typography">
      {/* Content goes here */}
      { modulesToRender.map( ({Module, id}) =>  <Module key={id} /> )}
      <PageNav 
        prev={{ text: "Photography", linkTo: "/photography" }} 
        next={{  text: "On Pack Claims", linkTo: "/onpackclaims"}}
      />
  </Layout>
  </>
)}

export default Typography


export const TypographyQuery = graphql`
  query TypographyQuery {
  page: contentfulPage(pageId: {eq: "typography"}) {
      ...PageFragment
    }
  }
`
